import { FileUp } from "lucide-react"
import type { NotificationRenderer } from "../../types"
import { navigateForAction } from "../actionRoutes"

// Icon mirrors the sidebar's questionnaire entry (AppSidebarV2 ICONS.upload);
// the "error" accent chip carries the failure signal.
// Payload is untrusted: type-guard before using a field as a param.
export const questionnaireFailed: NotificationRenderer = {
  icon: FileUp,
  accent: "error",
  title: (payload) =>
    typeof payload?.filename === "string"
      ? { key: "NOTIF/QUESTIONNAIRE_FAILED/TITLE", params: { filename: payload.filename } }
      : { key: "NOTIF/QUESTIONNAIRE_FAILED/TITLE_GENERIC" },
  description: () => ({ key: "NOTIF/QUESTIONNAIRE_FAILED/DESC" }),
  cta: "NOTIF/CTA/OPEN_QUESTIONNAIRE",
  onAction: navigateForAction,
}
